import { ViewModel, View } from "binder"
import { NetworkedStationEditorView } from "./networkedStationEditor-view"
import { INetworkedStation } from "../INetworkedStation";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";

export class NetworkedStationEditorViewModel extends ViewModel implements INetworkedStation, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;
    }
    GetDefaultView(): View<ViewModel> {
        return new NetworkedStationEditorView();
    }
    public getTypeId(): string {
        return "VM-EBB70D8D-8BAB-4966-B069-145F750E01B3"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set macAddress(v: string) { this._macAddress = v; } public get macAddress(): string { return this._macAddress; } private _macAddress: string;

    closePopup(result?: any) {

    }

    async cloneTo(networkedStation: INetworkedStation) {
        networkedStation.id = this.id;
        networkedStation.macAddress = this.macAddress;
    }

    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت ایستگاه جمع آوری اطلاعات');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت مک آدرس تکراری وجود ندارد.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('ایستگاه جمع آوری اطلاعات با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت ایستگاه جمع آوری اطلاعات', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.macAddress)) {
            result.push('مک آدرس مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(networkedStation: INetworkedStation): Promise<any>;
}

export class NetworkedStationInserter implements IServerUpdater {
    async execute(networkedStation: INetworkedStation): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/DataCollectionStationServices/CreateNetworkedStation', {
                MacAddress: networkedStation.macAddress
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class NetworkedStationUpdater implements IServerUpdater {
    async execute(networkedStation: INetworkedStation): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/DataCollectionStationServices/UpdateNetworkedStation', {
                NetworkedStationId: networkedStation.id,
                MacAddress: networkedStation.macAddress
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
